function Player(selectorID, isYoutube) {
	this.id = selectorID;
	this.isYoutube = isYoutube;
	this.ytplayer = undefined;
}

Player.prototype.play = function() {
	if(this.isYoutube) {
		if(this.ytplayer !== undefined && typeof this.ytplayer.playVideo === 'function' ) {
			this.ytplayer.playVideo();
		}
	}
	else {
		document.getElementById('video-frame').play();
	}
};

Player.prototype.pause = function() {
	if(this.isYoutube) {
		if(this.ytplayer !== undefined && typeof this.ytplayer.playVideo === 'function' ) {
			this.ytplayer.pauseVideo();
		}
	}
	else {
		document.getElementById('video-frame').pause();
	}
};

if(document.getElementById('video-frame-yt')) {
	var player = new Player('video-frame-yt', true);
	onYouTubeIframeAPIReady = function() {
		player.ytplayer = new YT.Player(player.id);
	  };
}
else {
	var player = document.getElementById('video-frame');
}

(function($, player){
	var isPlaying = false;
	$('.responsive-embed--overlay').on('click', function() {
		$('.js-ct-component-videoplayer').toggleClass('is-playing');
		isPlaying = ! isPlaying;
		if(isPlaying) {
			player.play();
		}
		else {
			player.pause();
		}
	});

}(jQuery, player));